import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=463ff20e&scoped=true&"
import script from "./FormStep.vue?vue&type=script&lang=js&"
export * from "./FormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ff20e",
  null
  
)

export default component.exports